import React, { forwardRef } from "react";

import { format } from "date-fns";

import { Box, Flex, Spacer, Text, HStack } from "@chakra-ui/react";

import logoMCA from "../../../img-docs/logomca.png";
import { DadosPrincipais } from "./DadosPrincipais";
import { Perfil } from "./Perfil";
import { Gestao } from "./Gestao";
import { Regularidade } from "./Regularidade";
import { Planejamento } from "./Planejamento";
import { Equipe } from "./Equipe";
import { RedeReferencia } from "./RedeReferencia";
import { Voluntariado } from "./Voluntariado";
import { PessoaEmCumprimento } from "./PessoaEmCumprimento";
import { FamiliaAcolhedora } from "./FamiliaAcolhedora";
import { Anexos } from "./Anexos";
import {
  criancaFunc,
  Permission,
  servicoAcolhimentoFunc,
  servicos,
} from "../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../Context/AuthProvider";
import { useAppContext } from "../../../Context/MessageContextProvider";
import { Pendencias } from "./Pendencias";
import { ProgramaApadrinhamento } from "./ProgramaApadrinhamento";

export const ComponentToPrint = forwardRef((props, ref) => {
  const { roleKeycloack, user } = useAuthProvider();
  const { idPJ } = useAppContext();

  return (
    <Box display="block" ref={ref}>
      <table width={props.previewLayout ? "100%" : ""}>
        {!props.previewLayout && (
          <thead>
            <tr>
              <td>
                {/* Header Spacer */}
                <Box height="100px" />
              </td>
            </tr>
          </thead>
        )}
        <tbody>
          <tr>
            <td>
              <Box display="block" px="15px">
                {roleKeycloack &&
                (roleKeycloack.includes(
                  criancaFunc.visualizarTudoAcolhimento,
                ) ||
                  roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
                !user?.orgaoExterno?.includes(
                  props.dataSA?.idPessoaJuridica,
                ) ? (
                  <>
                    <DadosPrincipais
                      data={props?.dataSA}
                      dataPerfil={props?.dataPerfil}
                      previewLayout={props?.previewLayout}
                    />
                    <Perfil data={props?.dataPerfil} />
                  </>
                ) : (
                  <>
                    <DadosPrincipais
                      data={props?.dataSA}
                      dataPerfil={props?.dataPerfil}
                      previewLayout={props?.previewLayout}
                    />
                    <Perfil data={props?.dataPerfil} />
                    <Gestao data={props?.dataGestao} />
                    <Regularidade data={props?.dataRegularidade} />
                    <Planejamento data={props?.dataPlanejamento} />

                    {roleKeycloack &&
                    roleKeycloack?.includes(
                      servicos.servicoNoImprimir,
                    ) ? undefined : (
                      <Equipe data={props?.dataEquipe} />
                    )}

                    <RedeReferencia data={props?.dataRedeReferencia} />
                    {(props?.dataSA
                      ? props?.dataSA?.tipoServicoAcolhimento?.regime === "SAI"
                      : false) && (
                      <>
                        {roleKeycloack &&
                        roleKeycloack?.includes(
                          servicos.servicoNoImprimir,
                        ) ? undefined : (
                          <>
                            <Voluntariado data={props?.dataVoluntariado} />

                            <PessoaEmCumprimento
                              data={props?.dataPessoaEmCumprimento}
                            />
                          </>
                        )}
                      </>
                    )}
                    <Permission
                      roleKeycloack={roleKeycloack}
                      func={servicoAcolhimentoFunc.visualizarApadrinhamentoServ}
                      id={idPJ}
                      user={user}
                      visualizar={true}
                    >
                      <ProgramaApadrinhamento
                        data={props?.dataProgramaApadrinhamento}
                      />
                    </Permission>
                    {(props?.dataSA
                      ? props?.dataSA?.tipoServicoAcolhimento?.regime === "SAF"
                      : false) && (
                      <>
                        {roleKeycloack &&
                        roleKeycloack?.includes(
                          servicos.servicoNoImprimir,
                        ) ? undefined : (
                          <FamiliaAcolhedora
                            data={props?.dataFamiliaAcolhedora}
                          />
                        )}
                      </>
                    )}
                    <Anexos data={props?.dataAnexos} dataSA={props?.dataSA} />

                    <Permission
                      roleKeycloack={roleKeycloack}
                      func={servicos.pendenciasServVisualizar}
                      id={idPJ}
                      user={user}
                      visualizar={true}
                    >
                      <Pendencias data={props?.dataPendencias} />
                    </Permission>
                  </>
                )}
              </Box>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              {/* Footer Spacer */}
              <Box height="40px" />
            </td>
          </tr>
        </tfoot>
      </table>

      {/* Header */}
      <HStack
        position="fixed"
        top={0}
        px="15px"
        pt="17.5px"
        pb="10px"
        spacing="40px"
        alignItems="center"
        backgroundColor="#FFF"
        zIndex={100}
        width="100%"
        display={props.previewLayout ? "none" : ""}
      >
        <img
          src={logoMCA}
          alt="LogoMCA"
          style={{ width: "200px", height: "60px" }}
        />
        <Text
          fontWeight={700}
          fontSize="20px"
          lineHeight="21.6px"
          color="#464648"
        >
          {"Ficha do serviço de acolhimento".toUpperCase()}
        </Text>
      </HStack>
      {/* Footer */}
      <Flex
        position="fixed"
        bottom={0}
        pb="17.5px"
        pt="10px"
        w="100%"
        px="15px"
        backgroundColor="#FFF"
        zIndex={100}
        display={props.previewLayout ? "none" : ""}
      >
        <HStack spacing="35px">
          <Text>{format(new Date(), "dd/MM/yyyy")}</Text>
          <Text>{format(new Date(), "HH:mm:ss")}</Text>
        </HStack>

        <Spacer />

        <Text id="pageForPrint">Página</Text>
      </Flex>
    </Box>
  );
});
